export default __webpack_public_path__ + "8ee2e989cb1d5daff7075efc6ea1135b.wav";